import React, { useState, useContext, useRef } from 'react';
import {
  DirectionsService,
  DirectionsRenderer,
} from '@react-google-maps/api';

import styled from 'styled-components/macro';

import { MapFilterDataContext } from '../contexts/MapFilterDataContext';
import useCurrentLocation from '../custom-hooks/useCurrentLocation';
import callLogo1 from '../images/call1.png';
import carLogo1 from '../images/sports-car.png';
import carLogo2 from '../images/car1.png';
import googleMapLogo from '../images/google-maps-logo.png';
import { MapInfoContext } from '../contexts/MapInfoContext';
import useOutsideAlerter from '../custom-hooks/useOutsideAlerters';
import { LangContext } from '../contexts/LangContext';

interface DirectionBarProps {}

const DirectionBar: React.FC<DirectionBarProps> = () => {
  const { coords: currentCoords } = useCurrentLocation();
  const {
    viewingPoint,
    handleSetIsShowingDirection,
    handleCancelShowingDirection,
    isShowingDirection,
  } = useContext(MapInfoContext);
  const { currentLangData } = useContext(LangContext);
  const showDirButtonRef = useRef(null);
  useOutsideAlerter(showDirButtonRef, () => {
    handleCancelShowingDirection();
  });

  const switchCarIcon = () => {
    if (isShowingDirection) {
      return carLogo2;
    } else {
      return carLogo1;
    }
  };

  const onClickShowDirection = () => {
    console.log(
      `onClickShowDirection lat ${currentCoords.lat} lng ${currentCoords.lng}`,
    );
    handleSetIsShowingDirection(true);
  };
  const calling = (viewingPoint: any) => {
    console.log(`Call : ${viewingPoint.telephone}`);
    if (viewingPoint.telephone) {
      window.open(`tel://${viewingPoint.telephone}`, '_top');
    }
  };
  /**
   * open google map with the lat lng
   */
  const handleClickLinkGoogleMap = () => {
    window.location.href = `https://maps.app.goo.gl/?link=https://www.google.com/maps/dir//${viewingPoint.lat},${viewingPoint.lng}/@${currentCoords.lat},${currentCoords.lng},14z`;
  };
  return (
    <SDirectionBar>
      {viewingPoint.telephone != null && (
        <SButton onClick={() => calling(viewingPoint)}>
          <SIconCall src={callLogo1} style={{ height: 16 }} />
          <SLabel>{currentLangData.call}</SLabel>
        </SButton>
      )}

      <SButton
        ref={showDirButtonRef}
        onClick={() => handleClickLinkGoogleMap()}
      >
        <SIconDirec src={switchCarIcon()} style={{ height: 21 }} />
        <SLabel>{currentLangData.onGoogleMap}</SLabel>
      </SButton>
    </SDirectionBar>
  );
};

export default DirectionBar;

const SIconCall = styled.img`
  height: 16px;
  margin: 0 0.7rem;
`;
const SIconDirec = styled.img`
  height: 21px;
  margin: 0 0.7rem;
`;

const SLabel = styled.div`
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.common.white};
  font-weight: ${(props) => props.theme.fontWeights.title};
  font-family: ${(props) => props.theme.fontFamilies.title};
`;

const SDirectionBar = styled.div`
  font-family: ${(props) => props.theme.fontFamilies.body};
  display: flex;
  width: 100%;
  height: 2.3rem;
  background: ${(props) =>
    props.theme.colors.text.primary}; // #576d70;
  position: absolute;
  bottom: 0;
  box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.25);
  left: 0;
`;
const SGoogleMap = styled.div`
  background: #ffffff;
  // width: 2.3rem;
  // height: 2.3rem;
  width: 2.3rem;
  height: 2.3rem;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px ${(props) => props.theme.colors.text.primary};
`;
const SIconGMap = styled.img`
  height: 2rem;
  width: 2rem;
`;
const SButton = styled.button`
  height: 2.3rem;
  background: ${(props) => props.theme.colors.text.primary};
  border: none;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  &:first-of-type {
    border-right: solid 1px
      ${(props) => props.theme.colors.common.white};
  }
`;
